import { Button } from "@material-ui/core";
import { NotificationsNone } from "@material-ui/icons";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getUserMessages, markUserMessageAsRead } from "../../../../api/message";
import { ROLES } from "../../../../utils/constants";

const POLLING_INTERVAL_MS = 5000;

const formatDate = (value) => {
  const date = value ? new Date(value) : null;
  if (!date || Number.isNaN(date.getTime())) return "";
  return date.toLocaleString("es-ES", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
};

export function HeaderMessages() {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState({ items: [], total: 0 });
  const menuRef = useRef(null);
  const mountedRef = useRef(false);
  const loggedUser = useSelector((store) => store.authentication?.user, shallowEqual);
  const accessToken = loggedUser?.accessToken;
  const canReadMessages = loggedUser?.role?.rango === ROLES.SUPER_ADMIN || loggedUser?.role?.rango === ROLES.ADMIN;

  const loadMessages = useCallback(async () => {
    if (!accessToken || !canReadMessages) return;
    try {
      const response = await getUserMessages(accessToken, "no_leidos", 1, 5);
      if (response.status === 200 && mountedRef.current) setMessages(response.data || { items: [], total: 0 });
    } catch {
      // The inbox is supplementary and must not disrupt the header on a temporary failure.
    }
  }, [accessToken, canReadMessages]);

  useEffect(() => {
    mountedRef.current = true;
    return () => { mountedRef.current = false; };
  }, []);

  useEffect(() => {
    loadMessages();
    const intervalId = window.setInterval(loadMessages, POLLING_INTERVAL_MS);
    return () => window.clearInterval(intervalId);
  }, [loadMessages]);

  useEffect(() => {
    window.addEventListener("neo4:messages-changed", loadMessages);
    return () => window.removeEventListener("neo4:messages-changed", loadMessages);
  }, [loadMessages]);

  useEffect(() => {
    const closeOnOutsideClick = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) setOpen(false);
    };
    document.addEventListener("mousedown", closeOnOutsideClick);
    return () => document.removeEventListener("mousedown", closeOnOutsideClick);
  }, []);

  const handleMarkAsRead = async (messageId) => {
    try {
      await markUserMessageAsRead(messageId, accessToken);
      await loadMessages();
    } catch {
      // The message remains unread and can be retried from the full inbox.
    }
  };

  if (!canReadMessages) return null;

  const unreadCount = messages.total || 0;
  return (
    <div ref={menuRef} style={{ position: "relative" }}>
      <button type="button" className="neo4-header-action" title="Mensajes" onClick={() => setOpen((current) => !current)} style={{ position: "relative" }}>
        <NotificationsNone fontSize="small" />
        {unreadCount > 0 && <span style={{ position: "absolute", top: "-6px", right: "-6px", minWidth: "18px", height: "18px", padding: "0 4px", borderRadius: "9px", background: "#F64E60", color: "#FFF", fontSize: "10px", fontWeight: 700, lineHeight: "18px" }}>{unreadCount > 99 ? "99+" : unreadCount}</span>}
      </button>
      {open && <div style={{ position: "absolute", zIndex: 1100, right: 0, top: "calc(100% + 10px)", width: "390px", maxWidth: "calc(100vw - 32px)", background: "#FFF", border: "1px solid #E4E6EF", borderRadius: "0.42rem", boxShadow: "0 8px 18px rgba(0,0,0,.14)", overflow: "hidden" }}>
        <div className="d-flex justify-content-between align-items-center px-4 py-3" style={{ borderBottom: "1px solid #E4E6EF" }}><strong>Mensajes</strong><span className="text-muted small">{unreadCount} sin leer</span></div>
        {!messages.items?.length ? <div className="p-5 text-muted text-center">No hay mensajes pendientes.</div> : messages.items.map((message) => <div key={message.id} className="px-4 py-3" style={{ borderBottom: "1px solid #F1F1F5" }}>
          <div className="d-flex justify-content-between" style={{ gap: "12px" }}><strong style={{ fontSize: "0.9rem" }}>{message.titulo}</strong><span className="text-muted text-nowrap" style={{ fontSize: "0.75rem" }}>{formatDate(message.fecha)}</span></div>
          <div className="text-muted mt-1" style={{ fontSize: "0.82rem", lineHeight: 1.35 }}>{message.mensaje}</div>
          <Button size="small" color="primary" className="mt-2 px-0" onClick={() => handleMarkAsRead(message.id)}>Marcar como leído</Button>
        </div>)}
        <div className="p-3 text-center"><Link to="/configuracion/mensajeria" onClick={() => setOpen(false)} className="font-weight-bolder">Ver mensajes</Link></div>
      </div>}
    </div>
  );
}
